import {
  getAnalytics,
  isSupported,
  logEvent,
  type Analytics,
} from "firebase/analytics";
import { getFirebaseApp } from "./app";

let analyticsPromise: Promise<Analytics | null> | null = null;

/**
 * Analytics is initialized on the client only and only when supported
 * (no SSR / restricted browsers). Returns null when unsupported.
 */
export function getAnalyticsInstance(): Promise<Analytics | null> {
  if (analyticsPromise) return analyticsPromise;
  analyticsPromise = isSupported().then((supported) =>
    supported ? getAnalytics(getFirebaseApp()) : null,
  );
  return analyticsPromise;
}

export async function trackEvent(
  name: string,
  params?: Record<string, unknown>,
): Promise<void> {
  const analytics = await getAnalyticsInstance();
  if (!analytics) return;
  logEvent(analytics, name, params);
}
